<template>
  <CommonTabs
    v-bind:key="$route.params.id"
    :id="$props.id"
    resource="visualizations"
    :tabs="tabs"
    :components="components"
    :default-router="{ name: 'visualizations' }"
    :tab.sync="tab"
  ></CommonTabs>
</template>

<script>
import CommonTabs from "@/components/common/tabs/CommonTabs.vue";
import { projectTitle } from "@/components/mixins/projects/projectTitle";
import EditVisualization from "@/components/projects/metering/visualizations/EditVisualization.vue";
import DeleteVisualization from "@/components/projects/metering/visualizations/DeleteVisualization.vue";
import NewVisualization from "@/components/projects/metering/visualizations/NewVisualization.vue";

export default {
  name: "Visualization",
  mixins: [projectTitle],
  components: {
    CommonTabs
  },
  props: ["project_id", "id"],
  data: () => ({
    components: {
      EditVisualization,
      DeleteVisualization,
      NewVisualization
    },
    tab: 0
  }),
  computed: {
    tabs() {
      if (!this.$props.id) {
        return [
          {
            component: "NewVisualization",
            title: "create"
          }
        ];
      } else {
        return [
          {
            component: "EditVisualization",
            title: "edit"
          },
          {
            component: "DeleteVisualization",
            title: "delete"
          }
        ];
      }
    },
    visualization: {
      get() {
        return this.$store.getters[
          "projectMeteringStore/visualizationStore/getItem"
        ];
      }
    },
    breadcrumbs() {
      return this.visualization.id
        ? [
            {
              text: this.$t("visualizations.visualizations"),
              to: {
                name: "visualizations",
                params: {
                  project_id: this.project.id
                }
              },
              exact: true
            },
            {
              text: this.visualization.name,
              to: {
                name: "visualizations",
                params: {
                  project_id: this.project.id,
                  id: this.visualization.id
                }
              },
              exact: true
            }
          ]
        : [
            {
              component: "NewVisualization",
              title: "create"
            }
          ];
    } // didnt delete for on purpose might be used in future
  },
  watch: {
    visualization: function() {
      this.setTitle();
    }
  },
  methods: {
    getArgumentForTitle() {
      return {
        chain: [
          this.$t("visualizations.visualizations"),
          this.visualization.name
        ]
      };
    }
  },
  mounted() {
    this.$props.id &&
      this.$store.dispatch("projectMeteringStore/visualizationStore/get", {
        id: this.$props.id,
        project_id: this.$props.project_id
      });
  }
};
</script>
